import SwiperCore, { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper';
import { Swiper as SwiperComponent, SwiperSlide } from 'swiper/react';
import Swiper from 'swiper'

import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';
import 'swiper/components/pagination/pagination.scss';
import 'swiper/components/scrollbar/scrollbar.scss';

import { tabs, floorList, businessList, events } from '../constant/constant'
import '../App.css';
import '../css/index.scss';
import { Component } from 'react';

SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Autoplay]);

class Index extends Component {
  constructor(props) {
    super(props);

    this.state = {
      index: 0,
    };
  }

  componentDidMount() {
    this.swiperObj = new Swiper('.swiper-container', {
      // slidesPerView: 1,
      // loop: false,
      // pagination: {
      //   clickable: true,
      // },
      // autoplay: {// 自动滑动
      //   delay: 3000, //3秒切换一次
      //   disableOnInteraction: false,
      // },
    })
  }

  toDetail(url, e) {
    window.open(url)
    e.stopPropagation()
  }

  render() {
    return (
      <div className="App">
        {/* 单页面 */}
        <div className="banner">
          <div className='jianzhen'>
            <img className="logo" src={'logo.png'} alt="" />
            <div className='h-line' ></div>
            <div className='text2' >集鉴别、溯源、回收等服务为一体</div>
            <div className='text3' >专业老酒鉴别体系</div>
          </div>
          <img src={`1_1.jpg`} className="banner" alt="" />
        </div>

        {/* 单页面 */}
        {floorList.map((item) => {
          return (
            <div className="banner" key={item.img}>
              <div className='about-jianzhen'>
                <div className='text0'>{item.text1}</div>
                <div className='text0'>{item.text2}</div>
                <div className='text1' >{item.text3}</div>
                {item.text3_1 && <div className='text1' >{item.text3_1}</div>}
                <div className='line-wrapper'>
                  <span className='line'></span>
                  <span className='dot'></span>
                </div>
                <div className='text3' >{item.text4}</div>
              </div>

              <img src={`${item.img}.jpg`} className="banner" alt="" />
            </div>)
        })}

        {/* 中间轮播图 */}
        <div className='custom-swipper-wrapper'>
          <SwiperComponent
            slidesPerView={1}
            onActiveIndexChange={(swiper) => {
              this.setState({ index: swiper.activeIndex })
            }}
            className='banner'
            initialSlide={0}
            autoHeight
          >
            {tabs.map((item) => {
              return (
                <SwiperSlide key={item.text2} className='banner'>
                  <div className='tab-item'>
                    <div className='text1' >{item.text1}</div>
                    <span className='text2' >{item.text2}</span>
                    <div className='text3' dangerouslySetInnerHTML={{__html: item.text3}}/>
                  </div>

                  <img src={`${item.img}.jpg`} className="banner" alt="" />
                </SwiperSlide>
              )
            })}
          </SwiperComponent>

          <div className='tabs'>
            <div className='item-bg'>
              {
                tabs.map((item, index) => {
                  return <span key={item.text2} className={this.state.index === index ? 'item active' : 'item'} onClick={() => {
                    this.setState({ index })
                    this.swiperObj[0].slideTo(index, 1000, false)
                  }}>{item.text2}</span>
                })
              }
            </div>
          </div>
        </div>

        {/* 单页面 */}
        {businessList.map((item) => {
          return (
            <div className="banner" key={item.img}>
              <div className='about-jianzhen'>
                <div className='text0'>{item.text1}</div>
                <div className='text0'>{item.text2}</div>
                <div className='text1' >{item.text3}</div>
                {item.text3_1 && <div className='text1' >{item.text3_1}</div>}
                <div className='line-wrapper'>
                  <span className='line'></span>
                  <span className='dot'></span>
                </div>
                {item.text4_min && <div className='text2_min' >{item.text4_min}</div>}
                {item.text5_min && <div className='text2_min' >{item.text5_min}</div>}
                {item.text4 && <div className='text2' >{item.text4}</div>}
                {item.text5 && <div className='text2' >{item.text5}</div>}
              </div>

              <img src={`${item.img}.jpg`} className="banner" alt="" />
            </div>)
        })}

        {/* 事件 */}
        <div className='event-wrapper'>
          <SwiperComponent
            // slidesPerView={'auto'}
            // spaceBetween={100}
            // slidesOffsetBefore={100}
            // initialSlide={0}
            // loopedSlides={1}
            // loop
            preventClicksPropagation={false}
            slideToClickedSlide={false}
            autoplay={{
              delay: 4000,
              // stopOnLastSlide: true
            }}
            pagination={{ clickable: true }}
            className='event-content'
          >
            {events.map((item) => {
              return (
                <SwiperSlide className='event' key={item.text2}>
                  <div className='event-item'>
                    <span className='text1'>最新动态</span>
                    <div className='text2' dangerouslySetInnerHTML={{__html: item.text1}} />
                    <div className='text3'dangerouslySetInnerHTML={{__html: item.text2}} />
                    {item.url && <button className='button' onClick={this.toDetail.bind(this, item.url)}> {`了解更多 >`}</button>}
                  </div>

                  <img src={`${item.img}.jpg`} className="event" alt="" />
                </SwiperSlide>
              )
            })}
          </SwiperComponent>
        </div>

        <div className='footer'>
          <div className='wx-wrapper'>
            <div className='wx-content'>
              <div className='wx-jianzhen'>体验见甄</div>
              <img src={'wx_1.jpeg'} className="wx" alt="" />
              <div className='wx-jianzhen-text'>见甄小程序</div>
            </div>
          </div>

          <div className="link">
            <span className="link-text">友情链接：</span>
            <a href="https://www.moutaiclub.cn/" target="_blank" rel="noreferrer">
              <img src={'association.png'} className="association-icon" alt="" />
            </a>
            <a href="http://www.bjmoutaimuseum.com/" target="_blank" rel="noreferrer">
              <img src={'museum.png'} className="museum-icon" alt="" />
            </a>
          </div>
          <div className="copyright">
            <span className="left">Copyright © MOUTAIFANS.COM, All rights Reserved.</span>
            <span className="right">
              版权所有 见甄
              <span className="divide">|</span>
              <img src={'beian.png'} className="beian-icon" alt="" />
              <a href="https://beian.miit.gov.cn/" target="_blank" rel="noreferrer">
                京ICP备2022000624号
              </a>
            </span>
          </div>
        </div>
      </div>
    );
  }
}

export default Index;
